import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import MonthlyContests from "@/pages/MonthlyContests";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/contests")({
  head: () => seoHead("/contests"),
  component: () => (
    <AuthGate><MonthlyContests /></AuthGate>
  ),
});
